<NBToggle :label="$t('my_account.newsletter.option1')" v-model="subscribe" />
